module.exports = __webpack_public_path__ + "static/media/travel-travel2 2@2x.028808dd.png";